<div *ngIf="!showRequest">
    <h2 class="sectionTitle">{{'FRONT_USER.RESET_PASSWORD_FORM.RESET_PASSWORD' | translate }}</h2>
</div>

<!-- <div *ngIf="loginError" class="red ">
  {{'FRONT_USER.LOGIN_FORM.LOGIN_ERROR' | translate}}
</div> -->

<div *ngIf="!showRequest">
    <form [formGroup]="forgetPasswordForm" >
        <div class="form-container">
            <div class="form-group">
                <label for="Username">{{ 'FRONT_USER.RESET_PASSWORD_FORM.USER_NAME' | translate}}</label>
                <span class="red"> *</span>
                <input matInput type="email" readonly [(ngModel)]="userName" formControlName="username"
                    class="form-control" [ngClass]="{ 'is-invalid': submitted && f.username?.errors }" />
                <div *ngIf="submitted ||(f.username?.dirty && f.username?.errors)" class="red ">
                    <div *ngIf="f.username?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}</div>
                    <div *ngIf="f.username?.errors?.email">
                        {{'FRONT_USER.AGENT_REGISTRATION_FORM.AGENT_REPRESENTATIVE_FORM.NAME_EMAIL_ERROR' | translate}}
                    </div>
                </div>
            </div>

            <div class="form-group">
                <label for="New Password">{{'FRONT_USER.LOGIN_FORM.PASSWORD'| translate}}</label>
                <span class="red"> *</span>
                <input matInput type="password" formControlName="newpassword" class="form-control"
                    [ngClass]="{ 'is-invalid': submitted && f.newpassword?.errors }" />
                <div *ngIf="submitted ||(f.newpassword?.dirty && f.newpassword?.errors)" class="red">
                    <div *ngIf="f.newpassword?.errors?.required">{{'FRONT_USER.This_Field_Is_Required'| translate}}
                    </div>
                    <div *ngIf="f.newpassword?.errors?.passwordStrength"> {{'FRONT_USER.PASSWORD_ERROR'| translate}}
                    </div>

                </div>
            </div>

            <div class="form-group">
                <label for="Confirm Password">{{'FRONT_USER.REGISTRATION_FORM.CONFIRM_PASSWORD'| translate}}</label>
                <span class="red"> *</span>
                <input type="password" formControlName="confirmpassword" class="form-control"
                    [ngClass]="{ 'is-invalid': submitted && f.confirmpassword?.errors }" />
                <div *ngIf="submitted ||(f.confirmpassword?.dirty && f.confirmpassword?.errors)" class="red ">
                    <div *ngIf="f.confirmpassword?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}
                    </div>
                    <div *ngIf="f.confirmpassword?.errors?.mustMatch">
                        {{'FRONT_USER.REGISTRATION_FORM.CONFIRM_PASSWORD_ERROR' | translate}}</div>
                </div>
            </div>
        </div>
        <p class="btns-holder">
            <button Confirmation  (confirmationClick)="onSubmit()"  class="btn btn-primary SCAcustomBtn">{{ 'FRONT_USER.SAVE' | translate}}</button>
        </p>

    </form>
</div>


<!-- Confirmation -->
<div *ngIf="showRequest" class="alert alert-success" role="alert">
    <div class="alignC">
        <svg version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 300 300" xml:space="preserve"
            xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <g>
                <g>
                    <path
                        d="M150,0C67.157,0,0,67.157,0,150s67.157,150,150,150s150-67.157,150-150S232.843,0,150,0z M223.413,128.844l-76.696,69.434    c-1.88,1.704-4.072,2.85-6.367,3.452c-1.979,0.882-4.103,1.338-6.235,1.338c-3.794,0-7.594-1.398-10.566-4.217l-47.222-44.826    c-6.147-5.836-6.398-15.549-0.563-21.696c5.83-6.147,15.546-6.401,21.696-0.565l37.587,35.678l67.764-61.355    c6.282-5.688,15.987-5.208,21.675,1.076C230.174,113.448,229.694,123.153,223.413,128.844z">
                    </path>
                </g>
            </g>
        </svg>
        <p>{{ 'FRONT_USER.SUCCESS_MESSAGES.CHANGE_PASSWORD' | translate }}</p>
    </div>
</div>